<template>
    <b-container fluid>
        <b-row class="mt-5">
            <b-col class="text-center">
                <br>
                <h2>SELECT A SEASON</h2>
                <hr class="mt-1 mb-4"/>
            </b-col>
        </b-row>
        <b-row v-if="page" class="mt-4">
            <b-col md="4" >
                <router-link :to="{ name: 'theme', params: {season: 'winter'} }">
                    <img class="full-img" :src="fileResourceUrl(page.contentDataSet.winter_season.value)"
                         alt="Pin Image"/>
                </router-link>
            </b-col>
            <b-col md="4" >
                <router-link :to="{ name: 'theme', params: {season: 'all'} }">
                    <img class="full-img" :src="fileResourceUrl(page.contentDataSet.all_season.value)"
                         alt="Pin Image"/>
                </router-link>
            </b-col>
            <b-col md="4">
                <router-link :to="{ name: 'theme', params: {season: 'summer'} } ">
                    <img class="full-img" :src="fileResourceUrl(page.contentDataSet.summer_season.value)"
                         alt="Pin Image"/>
                </router-link>
            </b-col>
        </b-row>
    </b-container>

</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import ContentAPI from "@shared/_api/cms/content";

    export default {
        name: 'ThemeSelect',
        data() {
            return {
                page: null
            }
        },
        mounted() {
            ContentAPI.fetchPageByName("theme_select").then(result => {
                this.page = result;
            });
        },
        methods: {},
        computed: {
            ...mapState("account", ["user"]),
            ...mapGetters('account', ['hasRole']),
        }
    }

</script>

<style lang="scss" scoped>
    @import "~@shared/_assets/scss/constants";

    .full-img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }

</style>